document.addEventListener('DOMContentLoaded', function () {
    const productHandle = 'pass-entree-repas'; // Handle exact de ton produit
    const maxQuantity = 8;

    if (window.location.pathname.includes(productHandle)) {
        const addToCartButton = document.querySelector('button[name="add"]');

        if (addToCartButton) {
            addToCartButton.addEventListener('click', function (e) {
                const quantityInput = document.querySelector('input[name="quantity"]');
                
                if (parseInt(quantityInput.value) > maxQuantity) {
                    e.preventDefault();
                    alert(`Vous pouvez ajouter jusqu'à ${maxQuantity} pass maximum par commande. Pour plus, merci de nous contacter.`);
                    quantityInput.value = maxQuantity;
                }
            });
        }
    }
});

